export default __webpack_public_path__ + "static/media/campaign.b9161c89.svg";